"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchInputButton = void 0;
var ToggleMenuFlyout = _interopRequireWildcard(require("@ori-events/toggle-menu-flyout"));
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _context = require("../../../../context");
var _navigation = require("../../../../context/navigation");
var _hooks = require("../../../../hooks");
var _useTranslations = require("../../../../hooks/useTranslations");
var _constants = require("../../constants");
var _styles = require("../../styles");
var _SearchPreviewDialog = require("../SearchPreviewDialog");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const SCROLL_THRESHOLD = _presentationUtils.SEARCH_INPUT_HEIGHT + 5;
const SearchInputButton = ({
  showOnlyOn
}) => {
  const {
    showSearchOnScroll
  } = (0, _context.useAppConfig)();
  const {
    visible: isTopBannerVisible
  } = (0, _context.useTopAreaBanner)();
  const {
    activeMenu,
    hideSearchResultsTab,
    toggleActiveMenu
  } = (0, _navigation.useActiveMenu)();
  const {
    hide,
    show,
    isVisible,
    focus,
    blur,
    isManuallyOpened
  } = (0, _navigation.useSearchInput)();
  const isAccountSideMenuActive = activeMenu === ToggleMenuFlyout.MenuTypes.AccountSideMenu;
  const isMobile = (0, _hooks.useIsMobile)();
  const [searchInputButtonRef, position] = (0, _hooks.useElementPosition)();
  const inputRef = (0, _react.useRef)(null);
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const [prevScrollY, setPrevScrollY] = (0, _react.useState)(0);
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const onFocusHandler = (0, _react.useCallback)(() => {
    focus();
    inputRef.current?.blur();
    toggleActiveMenu(ToggleMenuFlyout.MenuTypes.SearchResults);
  }, [focus, toggleActiveMenu]);
  (0, _react.useEffect)(() => {
    const showWithoutFocus = () => {
      show();
      blur();
    };
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const difference = currentScrollY - prevScrollY;
      if (difference > SCROLL_THRESHOLD && isMobile && !isManuallyOpened && !isAccountSideMenuActive) {
        hide();
        hideSearchResultsTab();
      } else if (difference < -SCROLL_THRESHOLD && isMobile && !isAccountSideMenuActive) {
        showWithoutFocus();
      }
      setPrevScrollY(currentScrollY);
    };
    const handleScrollDebounced = (0, _mui.debounce)(handleScroll, 50);
    if (showSearchOnScroll) {
      window.addEventListener('scroll', handleScrollDebounced);
    }
    return () => window.removeEventListener('scroll', handleScrollDebounced);
  }, [isMobile, show, hide, blur, hideSearchResultsTab, isManuallyOpened, prevScrollY, showSearchOnScroll, isAccountSideMenuActive]);
  const isVisibleOnMobile = showOnlyOn === 'mobile' && isVisible;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SearchInputRoot, {
      isTopBannerVisible: isTopBannerVisible,
      isVisibleOnMobile: isVisibleOnMobile,
      showSearchOnScroll: showSearchOnScroll,
      showOnlyOn: showOnlyOn,
      "data-testid": getTestId(showOnlyOn === 'mobile' ? _constants.SEARCH_INPUT_ROOT_MOBILE : _constants.SEARCH_INPUT_ROOT_DESKTOP),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Inner, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.SearchInputBox, {
          ref: searchInputButtonRef,
          "data-testid": getTestId(_constants.SEARCH_INPUT_BOX),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Search, {
            fontSize: "medium",
            "data-testid": getTestId(_constants.SEARCH)
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SearchInputInput, {
            ref: inputRef,
            autoFocus: isManuallyOpened,
            type: "text",
            placeholder: translations.searchDesktop,
            "aria-label": translations.search,
            "data-testid": getTestId(_constants.SEARCH_INPUT),
            id: "main-search",
            onFocus: onFocusHandler
          })]
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SearchPreviewDialog.SearchPreviewDialog, {
      searchInputButtonPosition: position,
      showOnlyOn: showOnlyOn
    })]
  });
};
exports.SearchInputButton = SearchInputButton;
